/**
 * 設定頁（設計 v2 **S7**；UI v2 **步 9**）
 *
 *   字體大小／外觀／語言／通知／帳號同額度／私隱同匿名／匯出日記／關於
 *   ⚠️ 硬規則 B：頁面 ≤200 行 → 各段已拆去 `features/settings/*`。
 *   ⚠️ 頂欄用設計 **C02**（`variant: 'back'`）。
 */
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import TopBar from '../components/TopBar';
import PreferenceSections from '../features/settings/PreferenceSections';
import InfoSections from '../features/settings/InfoSections';

export default function SettingsPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="page">
      <TopBar
        variant="back"
        title={t('settings_title')}
        backLabel={t('settings_back_aria')}
        menuLabel={t('menu_open_aria')}
        onBack={() => navigate(-1)}
        onMenu={() => {
          /* 設定頁唔另開抽屜（避免疊兩層）；返回上頁即可 */
        }}
      />
      <div className="page__scroll">
        <div className="settings">
          <PreferenceSections />
          <InfoSections />
        </div>
      </div>
    </div>
  );
}
